import api, { handleResponse, handleError } from './api';

const params = (f) => ({
  days: f.days,
  excludeStaff: f.excludeStaff,
  excludeTest: f.excludeTest,
  excludeUserIds: (f.excludeUserIds || []).join(',') || undefined,
  take: f.take || undefined,
});

/** ANALYTICS reads. Both take the same filters so every number on the page agrees. */
const analyticsService = {
  async overview(filter) {
    try { return handleResponse(await api.get('/analytics/overview', { params: params(filter) })); } catch (e) { return handleError(e); }
  },
  async people(filter) {
    try { return handleResponse(await api.get('/analytics/people', { params: params(filter) })); } catch (e) { return handleError(e); }
  },
  /** One day on the traffic chart, drilled: who visited, where from, what they read. */
  async day(date, filter) {
    try { return handleResponse(await api.get('/analytics/day', { params: { ...params(filter), date } })); } catch (e) { return handleError(e); }
  },
  /** One person, everything the drawer draws. Needs `users · view`, not analytics. */
  async person(userId, days = 14) {
    try { return handleResponse(await api.get(`/analytics/people/${userId}`, { params: { days } })); } catch (e) { return handleError(e); }
  },
  /** One person on one day: their sessions in order and every step inside them. */
  async personDay(userId, date) {
    try { return handleResponse(await api.get(`/analytics/people/${userId}/day`, { params: { date } })); } catch (e) { return handleError(e); }
  },
};

export default analyticsService;
